<template>
  <mdb-card :class="isEnd ? 'grey lighten-5' : '' ">
    <mdb-card-body  class="p-2">
      <mdb-card-text>
        <div class="clearfix">
          <div class="bolder float-left"  :class="{'red-text': $isToday(lecture.test1Date)}">{{lecture.name}}</div>
          <div class="float-right">
            <mdb-icon v-if="open" class="p-0" icon="window-minimize" @click.native="onMinimize"/>
            <mdb-icon v-else class="p-0" icon="window-maximize" @click.native="onMaximize"/>
          </div>
        </div>
        <div v-if="open || !isEnd">
          <div><mdb-icon icon="clock"/> {{$strDate(lecture.startDate)}} ~ {{$strDate(lecture.endDate)}}</div>
          <div  :class="{'red-text': $isToday(lecture.test1Date)}">
            <mdb-icon icon="clock"/> 평가일: {{$strDate(lecture.test1Date)}}
          </div>
        </div>
        <div v-if="isStudent">
          필답: {{wScore}}, 수행: {{pScore}}, 태도: {{aScore}}
        </div>
      </mdb-card-text>
    </mdb-card-body>
  </mdb-card>
</template>
<script>
import { mdbIcon, mdbCard, mdbCardBody, mdbCardTitle, mdbCardText } from 'mdbvue';
import { mapGetters } from 'vuex';

export default {
  name: 'Lecture',
  components: { mdbIcon, mdbCard, mdbCardBody, mdbCardText },
  props: ['lecture'],
  data: () => ({
    open: false
  }),
  computed: {
    ...mapGetters('auth', ['isStudent']),
    isTestDate () {
      return this.$strDate(this.lecture.test1Date) === this.$strDate(new Date())
    },
    isBefore () {
      return this.$strDate(this.lecture.test1Date) > this.$strDate(new Date())
    },
    isEnd () {
      return this.$strDate(this.lecture.endDate) < this.$strDate(new Date())
    },
    wScore () {
      return 1;
    },
    pScore () {
      return 3
    },
    aScore () {
      return 2;
    }
  },
  methods: {
    onMinimize () {
      this.open = false;
    },
    onMaximize () {
      this.open = true;
    }
  }
}
</script>
